// ===========================================
// CUSTOM JS FOR Seniorenwoonhulp.NL
// Shared behavior only; page-specific interactions live in section scripts
// ===========================================

document.addEventListener('DOMContentLoaded', function() {
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');

  if (!mobileMenuBtn || !mobileMenu) return;

  let lastActiveElement = null;
  let scrollLockY = 0;
  const focusableSelector = 'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  const mobileMenuIcon = document.getElementById('mobile-menu-icon');
  const mobileMenuIconOpen = mobileMenuIcon ? mobileMenuIcon.querySelector('[data-menu-icon-open]') : null;
  const mobileMenuIconClose = mobileMenuIcon ? mobileMenuIcon.querySelector('[data-menu-icon-close]') : null;
  const getFocusableElements = () =>
    Array.from(mobileMenu.querySelectorAll(focusableSelector)).filter(
      (el) => !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true'
    );

  const openMenu = () => {
    if (!mobileMenu.classList.contains('hidden')) return;
    lastActiveElement = document.activeElement;
    scrollLockY = window.scrollY || window.pageYOffset || 0;

    mobileMenu.classList.remove('hidden');
    mobileMenu.removeAttribute('hidden');
    mobileMenu.setAttribute('aria-hidden', 'false');

    mobileMenuBtn.setAttribute('aria-expanded', 'true');

    if (mobileMenuIconOpen && mobileMenuIconClose) {
      mobileMenuIconOpen.classList.add('hidden');
      mobileMenuIconClose.classList.remove('hidden');
    }

    document.body.style.setProperty('--swh-scroll-lock-top', '-' + scrollLockY + 'px');
    document.body.dataset.menuScrollLockY = String(scrollLockY);
    document.body.classList.add('menu-open');

    const focusableElements = getFocusableElements();
    const firstFocusable = focusableElements[0] || mobileMenu;
    if (firstFocusable && typeof firstFocusable.focus === 'function') firstFocusable.focus();

    window.dispatchEvent(new Event('scroll'));
  };

  const closeMenu = () => {
    if (mobileMenu.classList.contains('hidden')) return;
    const lockedY = parseInt(document.body.dataset.menuScrollLockY || String(scrollLockY || 0), 10) || 0;

    mobileMenu.classList.add('hidden');
    mobileMenu.setAttribute('hidden', '');
    mobileMenu.setAttribute('aria-hidden', 'true');

    mobileMenuBtn.setAttribute('aria-expanded', 'false');

    if (mobileMenuIconOpen && mobileMenuIconClose) {
      mobileMenuIconOpen.classList.remove('hidden');
      mobileMenuIconClose.classList.add('hidden');
    }

    document.body.classList.remove('menu-open');
    document.body.style.removeProperty('--swh-scroll-lock-top');
    delete document.body.dataset.menuScrollLockY;
    mobileMenu.querySelectorAll('details[open]').forEach((details) => {
      if (!details.querySelector('[aria-current="page"]')) details.open = false;
    });
    window.scrollTo(0, lockedY);

    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    }
    lastActiveElement = null;
    scrollLockY = 0;

    window.dispatchEvent(new Event('scroll'));
  };

  const mobileMenuCloseBtn = mobileMenu.querySelector('[data-mobile-menu-close]');
  if (mobileMenuCloseBtn) {
    mobileMenuCloseBtn.addEventListener('click', closeMenu);
  }

  const toggleMenu = () => {
    if (mobileMenu.classList.contains('hidden')) {
      openMenu();
    } else {
      closeMenu();
    }
  };

  mobileMenuBtn.addEventListener('click', toggleMenu);

  mobileMenu.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (link) closeMenu();
  });

  document.addEventListener('keydown', (e) => {
    if (mobileMenu.classList.contains('hidden')) return;

    if (e.key === 'Escape') {
      closeMenu();
      return;
    }

    if (e.key !== 'Tab') return;

    const focusableElements = getFocusableElements();
    if (focusableElements.length === 0) {
      e.preventDefault();
      mobileMenu.focus();
      return;
    }

    const first = focusableElements[0];
    const last = focusableElements[focusableElements.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('focusin', (e) => {
    if (mobileMenu.classList.contains('hidden')) return;
    if (mobileMenu.contains(e.target)) return;

    const focusableElements = getFocusableElements();
    const firstFocusable = focusableElements[0] || mobileMenu;
    if (firstFocusable && typeof firstFocusable.focus === 'function') firstFocusable.focus();
  });

  window.toggleMobileMenu = toggleMenu;
});
